import { render } from "./Role.vue?vue&type=template&id=5dcd419c&scoped=true"
import script from "./Role.vue?vue&type=script&lang=ts"
export * from "./Role.vue?vue&type=script&lang=ts"

import "./Role.vue?vue&type=style&index=0&id=5dcd419c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5dcd419c"

export default script